module.exports = __webpack_public_path__ + "media/assets/community_index/alpha-sort-icon-71ecdd264b014fafb9e478df47eebd7d2f8aa68d848d22447484e7b4d1196e2a.png";